import styled from "styled-components";

export const Container = styled.div`
  div.topBar {
    height: 56px;
    border-bottom: 1px solid var(--gray-border);

    display: flex;
    align-items: center;

    div.btn-back {
      display: flex;
      margin-left: 32px;
      cursor: pointer;
      color: #0362a0;

      i {
        font-size: 1.2rem;
        margin-right: 16.25px;
      }
      p {
        font-size: 1.1rem;
        text-transform: capitalize;
      }
    }
  }

  div.error {
    padding: 40px 32px 0px;

    h1 {
      font-size: 1.25rem;
      font-weight: 900;
      margin-bottom: 24px;
    }

    p {
      font-size: 1rem;
    }

    p + p {
      margin: 24px 0px 24px;
      font-weight: 900;
    }
  }

  div.error-app {
    width: 90%;
    margin: 0 auto;
    margin-bottom: 72px;
    padding: 24px 16px 0px 16px;
    border-radius: 5px;

    background-color: var(--yellow-bg-modal);

    button {
      margin-bottom: 32px;
    }

    figure {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  @media (min-width: 760px) {
  }
`;
